import TableBranchScanCount from './table-branch-scan-count.container';

export default TableBranchScanCount;
